import { render, staticRenderFns } from "./LKFooter.vue?vue&type=template&id=32f9a8de&"
import script from "./LKFooter.vue?vue&type=script&lang=js&"
export * from "./LKFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports